/**
 * Keywords Scroll Handler
 * Handles smooth scrolling for the keywords bar
 */
document.addEventListener('DOMContentLoaded', function() {
    const keywordsScroll = document.querySelector('.gh-keywords-scroll');
    if (!keywordsScroll) return;

    // Variables for touch handling
    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse events
    keywordsScroll.addEventListener('mousedown', (e) => {
        isDown = true;
        keywordsScroll.style.cursor = 'grabbing';
        startX = e.pageX - keywordsScroll.offsetLeft;
        scrollLeft = keywordsScroll.scrollLeft;
    });

    keywordsScroll.addEventListener('mouseleave', () => {
        isDown = false;
        keywordsScroll.style.cursor = 'grab';
    });

    keywordsScroll.addEventListener('mouseup', () => {
        isDown = false;
        keywordsScroll.style.cursor = 'grab';
    });

    keywordsScroll.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - keywordsScroll.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        keywordsScroll.scrollLeft = scrollLeft - walk;
    });

    // Touch events
    keywordsScroll.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX - keywordsScroll.offsetLeft;
        scrollLeft = keywordsScroll.scrollLeft;
    });

    keywordsScroll.addEventListener('touchend', () => {
        isDown = false;
    });

    keywordsScroll.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.touches[0].pageX - keywordsScroll.offsetLeft;
        const walk = (x - startX) * 2;
        keywordsScroll.scrollLeft = scrollLeft - walk;
    });

    // Initialize cursor style
    keywordsScroll.style.cursor = 'grab';
});